/*
 * Custom product-gallery zoom lightbox.
 *
 * Opens on click of a main gallery image (img.product-media__image inside
 * [data-product-media-container]), shows a fullscreen popup with zoom (wheel /
 * buttons / double-click / pinch) and pan (drag), plus prev/next + keyboard.
 *
 * Opens instantly with the image already on screen, then swaps in a 2048px
 * hi-res version once it has loaded in the background.
 *
 * Markup + styles live in snippets/product-zoom-lightbox.liquid. The media
 * list is read from the [data-pzoom-data] JSON on each open, so it stays
 * correct even if the product section is re-rendered (variant change, etc.).
 */
(function () {
  var overlay = document.getElementById('pzoom');
  if (!overlay) return;

  var img = overlay.querySelector('[data-pzoom-img]');
  var stage = overlay.querySelector('[data-pzoom-stage]');
  var pctEl = overlay.querySelector('[data-pzoom-pct]');
  var countEl = overlay.querySelector('[data-pzoom-count]');

  var media = [];
  var idx = 0;
  var scale = 1, panX = 0, panY = 0;
  var pointers = {}, startDist = 0, startScale = 1;
  var dragId = null, dragOX = 0, dragOY = 0, dragPX = 0, dragPY = 0;

  var MIN = 1, MAX = 4;

  function readData() {
    var el = document.querySelector('[data-pzoom-data]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function norm(u) {
    try { return new URL(u, window.location.href).pathname; }
    catch (e) { return (u || '').split('?')[0]; }
  }

  function clampPan() {
    var maxX = (scale - 1) * (stage.clientWidth / 2);
    var maxY = (scale - 1) * (stage.clientHeight / 2);
    if (panX > maxX) panX = maxX; else if (panX < -maxX) panX = -maxX;
    if (panY > maxY) panY = maxY; else if (panY < -maxY) panY = -maxY;
  }

  function apply(anim) {
    clampPan();
    img.style.transition = anim ? 'transform .18s ease' : 'none';
    img.style.transform = 'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
    pctEl.textContent = Math.round(scale * 100) + '%';
    stage.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
  }

  function setScale(s, anim) {
    scale = Math.max(MIN, Math.min(MAX, s));
    if (scale === MIN) { panX = 0; panY = 0; }
    apply(anim !== false);
  }

  function load(immediate) {
    var m = media[idx];
    if (!m) return;
    scale = 1; panX = 0; panY = 0;
    img.alt = m.alt || '';
    img.src = immediate || m.src;
    var hi = new Image();
    hi.onload = function () { if (media[idx] === m) img.src = m.full; };
    hi.src = m.full;
    countEl.textContent = (idx + 1) + ' / ' + media.length;
    apply(false);
  }

  function openAt(i, immediate) {
    media = readData();
    if (!media.length) return;
    idx = Math.max(0, Math.min(media.length - 1, i));
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    load(immediate);
  }

  function close() {
    overlay.hidden = true;
    document.body.style.overflow = '';
    pointers = {}; dragId = null; startDist = 0;
  }

  function go(d) {
    idx = (idx + d + media.length) % media.length;
    load();
  }

  // Open from a click on a MAIN gallery image. Capture phase + stopPropagation
  // so the theme's draggable carousel doesn't swallow or double-handle it.
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('img.product-media__image') : null;
    if (!el || !el.closest('[data-product-media-container]')) return;

    var list = readData();
    if (!list.length) return;

    var i = -1;
    var slide = el.closest('[data-media-id]');
    if (slide) {
      var mid = slide.getAttribute('data-media-id');
      for (var k = 0; k < list.length; k++) {
        if (String(list[k].id) === String(mid)) { i = k; break; }
      }
    }
    if (i < 0) {
      var p = norm(el.currentSrc || el.src);
      for (var j = 0; j < list.length; j++) {
        if (norm(list[j].key) === p || norm(list[j].src) === p || norm(list[j].full) === p) { i = j; break; }
      }
    }
    if (i < 0) return;

    e.preventDefault();
    e.stopPropagation();
    openAt(i, el.currentSrc || el.src);
  }, true);

  overlay.querySelector('[data-pzoom-close]').addEventListener('click', close);
  overlay.querySelector('[data-pzoom-prev]').addEventListener('click', function () { go(-1); });
  overlay.querySelector('[data-pzoom-next]').addEventListener('click', function () { go(1); });
  overlay.querySelector('[data-pzoom-in]').addEventListener('click', function () { setScale(scale + 0.5); });
  overlay.querySelector('[data-pzoom-out]').addEventListener('click', function () { setScale(scale - 0.5); });

  // Click the dark backdrop (not the image/controls) to close.
  overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

  stage.addEventListener('wheel', function (e) {
    e.preventDefault();
    setScale(scale + (e.deltaY < 0 ? 0.3 : -0.3));
  }, { passive: false });

  stage.addEventListener('dblclick', function (e) {
    e.preventDefault();
    setScale(scale > 1 ? 1 : 2.5);
  });

  stage.addEventListener('pointerdown', function (e) {
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length === 2) {
      var a = pointers[ids[0]], b = pointers[ids[1]];
      startDist = Math.hypot(a.x - b.x, a.y - b.y);
      startScale = scale;
      dragId = null;
    } else if (scale > 1) {
      dragId = e.pointerId;
      dragOX = e.clientX; dragOY = e.clientY;
      dragPX = panX; dragPY = panY;
      try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      stage.style.cursor = 'grabbing';
    }
  });

  stage.addEventListener('pointermove', function (e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length === 2 && startDist) {
      var a = pointers[ids[0]], b = pointers[ids[1]];
      var d = Math.hypot(a.x - b.x, a.y - b.y);
      setScale(startScale * (d / startDist), false);
    } else if (dragId === e.pointerId) {
      panX = dragPX + (e.clientX - dragOX);
      panY = dragPY + (e.clientY - dragOY);
      apply(false);
    }
  });

  function endPointer(e) {
    delete pointers[e.pointerId];
    if (Object.keys(pointers).length < 2) startDist = 0;
    if (dragId === e.pointerId) {
      dragId = null;
      apply(true);
      stage.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', endPointer);

  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') go(-1);
    else if (e.key === 'ArrowRight') go(1);
    else if (e.key === '+' || e.key === '=') setScale(scale + 0.5);
    else if (e.key === '-') setScale(scale - 0.5);
  });
})();
